module.exports = __webpack_public_path__ + "assets/img/55f1c14365f324d4ac68af1e3ad8005b.png";